import { render, staticRenderFns } from "./vouchersList.vue?vue&type=template&id=cbee436c&scoped=true"
import script from "./vouchersList.vue?vue&type=script&lang=js"
export * from "./vouchersList.vue?vue&type=script&lang=js"
import style0 from "./vouchersList.vue?vue&type=style&index=0&id=cbee436c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbee436c",
  null
  
)

export default component.exports